import * as React from 'react';
import AccessibleSVG from 'box-ui-elements/es/icons/accessible-svg';
import { bdlGray80 } from 'box-ui-elements/es/styles/variables';

type Props = {
  className?: string;
  color?: string;
  height?: number;
  title?: string;
  width?: number;
};

const ListNumberIcon = ({
  className = '',
  color = bdlGray80,
  height = 16,
  title,
  width = 16,
}: Props) => (
  <AccessibleSVG
    className={className}
    height={height}
    title={title}
    viewBox="0 0 16 16"
    width={width}
  >
    <path
      clipRule="evenodd"
      d="M1.26019 5.07893H1.86729V3.48527C1.86729 3.40721 1.86946 3.32554 1.8738 3.24026L1.51604 3.53731C1.48424 3.56188 1.4528 3.5767 1.42172 3.58176C1.39064 3.58682 1.36137 3.58682 1.33391 3.58176C1.30644 3.5767 1.28187 3.5673 1.26019 3.55357L1.232 3.5327L1 3.22942L1.98438 2.40332H2.53945V5.07893H3.05983V5.56461H1.26019V5.07893Z"
      fill={color}
      fillRule="evenodd"
    />
    <rect
      fill={color}
      height="1.80645"
      rx="0.903226"
      width="10.8387"
      x="4.16094"
      y="3.08145"
    />
    <path
      clipRule="evenodd"
      d="M2.18196 6.91867C2.34073 6.91867 2.48369 6.94121 2.61086 6.98627C2.73802 7.03134 2.84644 7.09394 2.93611 7.17406C3.02579 7.25419 3.09452 7.34969 3.14229 7.46058C3.19007 7.57146 3.21396 7.69343 3.21396 7.8265C3.21396 7.94096 3.19742 8.04683 3.16435 8.14413C3.13127 8.24142 3.08606 8.33406 3.02873 8.42205C2.9714 8.51005 2.90487 8.59518 2.82916 8.67745L2.5877 8.92747V8.92747L1.95924 9.55415C2.04009 9.53126 2.11984 9.51302 2.19849 9.49943C2.27714 9.48583 2.35102 9.47904 2.42011 9.47904H3.01991C3.09341 9.47904 3.15148 9.49871 3.19412 9.53806C3.23675 9.5774 3.25806 9.62927 3.25806 9.69365V10.08H1V9.86535C1 9.82385 1.00882 9.7795 1.02646 9.73228C1.0441 9.68507 1.07497 9.64215 1.11908 9.60351L2.04524 8.69569C2.12462 8.61843 2.19372 8.54474 2.25252 8.47464C2.31132 8.40453 2.35984 8.33549 2.39806 8.26753C2.43628 8.19957 2.46495 8.13161 2.48406 8.06365C2.50317 7.99568 2.51273 7.92379 2.51273 7.84796C2.51273 7.72348 2.48222 7.62798 2.42121 7.56144C2.3602 7.49491 2.26722 7.46165 2.14226 7.46165C2.04083 7.46165 1.95519 7.48776 1.88536 7.53998C1.83881 7.5748 1.8019 7.61518 1.77462 7.66112L1.74093 7.73421C1.71006 7.8129 1.66963 7.86513 1.61964 7.89088C1.56966 7.91663 1.49836 7.92236 1.40575 7.90805L1.0441 7.84581C1.06762 7.68986 1.11283 7.55393 1.17972 7.43804C1.24661 7.32215 1.32967 7.22557 1.4289 7.14831C1.52813 7.07105 1.6417 7.01346 1.76959 6.97554C1.89749 6.93763 2.03495 6.91867 2.18196 6.91867Z"
      fill={color}
      fillRule="evenodd"
    />
    <rect
      fill={color}
      height="1.80645"
      rx="0.903226"
      width="10.8387"
      x="4.16094"
      y="7.5968"
    />
    <path
      clipRule="evenodd"
      d="M2.2142 11.4359C2.37144 11.4359 2.5112 11.4575 2.63349 11.5006C2.75579 11.5438 2.85915 11.6022 2.9436 11.6758C3.02804 11.7494 3.09209 11.8347 3.13577 11.9316C3.17945 12.0286 3.20129 12.1308 3.20129 12.2384C3.20129 12.3361 3.19109 12.4221 3.17071 12.4964C3.15033 12.5707 3.12012 12.6351 3.08008 12.6896C3.04005 12.7441 2.99055 12.7904 2.93158 12.8286C2.87262 12.8668 2.80529 12.8987 2.72958 12.9242C3.08191 13.0431 3.25806 13.2759 3.25806 13.6227C3.25806 13.7869 3.22749 13.9298 3.16634 14.0515C3.1052 14.1733 3.0233 14.2745 2.92067 14.3551C2.81803 14.4358 2.69901 14.4963 2.56361 14.5367C2.42821 14.577 2.287 14.5972 2.13995 14.5972C1.98854 14.5972 1.85387 14.5812 1.73595 14.5494C1.61802 14.5176 1.5132 14.468 1.42148 14.4008C1.32976 14.3336 1.24932 14.2476 1.18016 14.1428C1.11101 14.0381 1.05096 13.9135 1 13.7692L1.30137 13.6503C1.37998 13.6205 1.45278 13.6128 1.51975 13.6269C1.58672 13.6411 1.63476 13.6736 1.66388 13.7246C1.72939 13.8421 1.79891 13.9273 1.87243 13.9804C1.94596 14.0335 2.03222 14.06 2.13122 14.06C2.20692 14.06 2.2728 14.0476 2.32885 14.0229C2.3849 13.9981 2.43149 13.9663 2.46862 13.9273C2.50574 13.8884 2.53377 13.8442 2.55269 13.7946C2.57162 13.7451 2.58108 13.6949 2.58108 13.6439C2.58108 13.5774 2.57635 13.5176 2.56689 13.4645C2.55742 13.4114 2.53085 13.3658 2.48718 13.3276C2.4435 13.2893 2.37762 13.26 2.28954 13.2395C2.20146 13.2189 2.07881 13.2087 1.92157 13.2087V12.7543C2.05406 12.7543 2.16106 12.7444 2.24259 12.7246C2.32412 12.7048 2.38709 12.6775 2.43149 12.6429C2.4759 12.6082 2.50538 12.5661 2.51994 12.5165C2.53449 12.467 2.54177 12.4125 2.54177 12.3531C2.54177 12.2313 2.51156 12.1376 2.45114 12.0717C2.39073 12.0059 2.29864 11.973 2.17489 11.973C2.07444 11.973 1.98963 11.9989 1.92048 12.0505C1.87437 12.085 1.83782 12.1249 1.8108 12.1704L1.77744 12.2427C1.74686 12.3205 1.70683 12.3722 1.65733 12.3976C1.60783 12.4231 1.53722 12.4288 1.4455 12.4146L1.08735 12.3531C1.11065 12.1988 1.15541 12.0643 1.22166 11.9497C1.2879 11.835 1.37016 11.7395 1.46843 11.6631C1.5667 11.5866 1.67917 11.5297 1.80583 11.4921C1.93249 11.4546 2.06861 11.4359 2.2142 11.4359Z"
      fill={color}
      fillRule="evenodd"
    />
    <rect
      fill={color}
      height="1.80645"
      rx="0.903226"
      width="10.8387"
      x="4.16094"
      y="12.1122"
    />
  </AccessibleSVG>
);

export default ListNumberIcon;
